if (!customElements.get('long-run-infinite-scroll')) {
  class LongRunInfiniteScroll extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this.abortController = null;
      this.observer = null;
    }

    connectedCallback() {
      if (this.observer || !this.dataset.nextUrl) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
        },
        { rootMargin: '600px 0px', threshold: 0 }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.abortController?.abort();
    }

    async loadNextPage() {
      if (this.loading || !this.dataset.nextUrl) return;

      const productGrid = document.getElementById('product-grid');
      const status = this.querySelector('[data-infinite-scroll-status]');
      if (!productGrid) return;

      this.loading = true;
      this.classList.remove('is-error');
      this.classList.add('is-loading');
      this.setAttribute('aria-busy', 'true');
      productGrid.setAttribute('aria-busy', 'true');
      if (status) status.textContent = 'Loading more products.';

      this.abortController = new AbortController();

      try {
        const requestUrl = new URL(this.dataset.nextUrl, window.location.origin);
        requestUrl.searchParams.set('section_id', this.dataset.sectionId);

        const response = await fetch(requestUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: this.abortController.signal,
        });

        if (!response.ok) throw new Error(`Product request failed with status ${response.status}`);

        const responseText = await response.text();
        const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
        const nextGrid = responseDocument.getElementById('product-grid');
        const nextLoader = responseDocument.querySelector('long-run-infinite-scroll');

        if (!nextGrid) throw new Error('The next product grid was not found.');

        const fragment = document.createDocumentFragment();
        Array.from(nextGrid.children).forEach((item) => fragment.appendChild(item));
        productGrid.appendChild(fragment);

        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(productGrid);
        }

        if (nextLoader?.dataset.nextUrl) {
          this.dataset.nextUrl = nextLoader.dataset.nextUrl;
          if (status) status.textContent = 'More products loaded.';
        } else {
          this.dataset.nextUrl = '';
          this.observer?.disconnect();
          if (status) status.textContent = 'All products loaded.';
          this.hidden = true;
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.classList.add('is-error');
          if (status) status.textContent = 'Products could not be loaded automatically. Use the Load more link to continue.';
        }
      } finally {
        this.loading = false;
        this.classList.remove('is-loading');
        this.removeAttribute('aria-busy');
        productGrid.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('long-run-infinite-scroll', LongRunInfiniteScroll);
}
